import { render } from "./App.vue?vue&type=template&id=604a92d0&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=604a92d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/PIPIPIG233666.github.io/PIPIPIG233666.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604a92d0"]])

export default __exports__